import { get, merge, isEmpty } from "lodash";
import PostSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/post";
import GetSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/get";
import PutSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/put";

// Helper function to extract pagination details
const extractPaginationDetails = (responseData, queryParams) => ({
  pageNumber: queryParams && queryParams.pageNumber ? queryParams.pageNumber + 1 : 1,
  size: get(responseData, "pageSize", 10),
  totalPages: get(responseData, "totalPages", 0),
  totalData: get(responseData, "totalData", 0),
});

// Helper function to commit sections or permissions
const commitData = (commit, setStore, responseData, paginationDetails) => {
  const data = Array.isArray(responseData) ? responseData : get(responseData, "content", []);
  commit(setStore, merge({ data }, paginationDetails));
  return data;
};

const executePostQuery = async (query, payload, notificationParams) => {
  const proxy = new PostSimpatraServiceProxy();
  const response = await proxy.execute(query, payload, notificationParams);
  return response ? response.data : null;
};

const executePutQuery = async (query, payload, notificationParams) => {
  const proxy = new PutSimpatraServiceProxy();
  const response = await proxy.execute(query, payload, notificationParams);
  return response ? response.data : null;
};
const executeGetQuery = async (query, queryParams = {}) => {
  const proxy = new GetSimpatraServiceProxy();
  const response = await proxy.execute(query, queryParams);
  return response ? response.data : null;
};

const createQuery = clientId => {
  const query = `accounts/v1/client/${clientId || ""}`;
  return query.replace(/\/$/, "");
};

const actionMap = {
  GET: executeGetQuery,
  POST: executePostQuery,
  UPDATE: executePutQuery,
};

const executeAction = async (type, query, params = {}, payload = null, notificationParams = null) => {
  const action = actionMap[type];

  if (!action) {
    console.error(`Unsupported action type: ${type}`);
    return null; // or throw an error if preferred
  }

  try {
    return await action(query, !isEmpty(payload) ? payload : params, notificationParams);
  } catch (error) {
    console.error(`Error executing ${type} action:`, error);
    throw error; // Rethrow the error for further handling if needed
  }
};

const executeClientAccessAPI = async ({ commit }, { payload = {}, type = "GET", queryParams } = {}) => {
  const clientId = payload.id || ""; // Use default value if id is not present
  const query = createQuery(clientId);
  const notificationParams = {
    displaySuccessMessage: true,
    successNotificationMsg: type === "POST" ? "New access was added successfully!" : "User access has been updated",
    successNotificationHeader: "Successfully Added!",
  };
  const response = await executeAction(type, query, queryParams, payload, notificationParams);
  if (response && type === "GET") {
    const paginationDetails = extractPaginationDetails(response, queryParams);
    return commitData(commit, "setAPIAccess", response, paginationDetails);
  }
  return response;
};

export default {
  executeClientAccessAPI,
};
